import React from 'react';
import { Alert, Stack, Typography } from '@mui/material';

import { LoadingButton } from '~/components/common';
import { TextField } from '~/components/common/form';
import { useLanguage } from '~/hooks/language';

interface Props {
  status?: string;
  isBusy: boolean;
}

export const SetupTwoFactorForm: React.FC<Props> = props => {
  const { status, isBusy } = props;
  const { translate } = useLanguage('ua');

  return (
    <Stack spacing={2.5}>
      {/* Fields */}
      <Stack spacing={1.5}>
        <Typography variant="h2" fontWeight={400} sx={{ mb: '10px' }}>
          {translate('invite.setupTwoFactorAuth.title')}
        </Typography>

        <Typography variant="h5" fontWeight={400}>
          {translate('invite.setupTwoFactorAuth.subtitle')}
        </Typography>

        <TextField
          name="code"
          label={translate('invite.setupTwoFactorAuth.code.placeholder')}
          fullWidth
          autoComplete="one-time-code"
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }}
        />
      </Stack>

      {/* Status */}
      {status && <Alert severity="error">{status}</Alert>}

      {/* Submit */}
      <LoadingButton
        loading={isBusy}
        type="submit"
        size="large"
        label={translate('invite.setupTwoFactorAuth.submit')}
        variant="contained"
        fullWidth
      />
    </Stack>
  );
};
